import React from 'react';
import styled from 'styled-components';

const OverlayAbsoluteStyled = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #FFF;
  opacity: 0.2;
`;

/** Semi-transparent absolutely-positioned overlay that fills its container. */
export const OverlayAbsolute = () => {
  return <OverlayAbsoluteStyled className="overlay" />;
};